import React from 'react'
import { Radio, Typography } from '@equinor/eds-core-react'
import styled from 'styled-components'
import { baseFont } from '@/styles'

interface RadioOption {
    label: string
    value: string
}

interface LabelWithRadioButtonsProps {
    label: string
    options: RadioOption[]
    selectedValue: string | null
    onChange: (value: string) => void
}

const LabelWithRadioButtons: React.FC<LabelWithRadioButtonsProps> = ({ label, options, selectedValue, onChange }) => {
    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value)
    }

    return (
        <RowStyle>
            <RadioInputStyledLabel>{label}</RadioInputStyledLabel>
            <RadioGroup>
                {options.map((option) => (
                    <StyledRadioContainer key={option.value}>
                        <StyledRadio
                            label={option.label}
                            name={label}
                            value={option.value}
                            checked={selectedValue === option.value}
                            onChange={onChangeRadio}
                        />
                    </StyledRadioContainer>
                ))}
            </RadioGroup>
        </RowStyle>
    )
}

const RowStyle = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    gap: 0;
`

const RadioGroup = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    flex-grow: 1;
`

const StyledRadioContainer = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: left;
    min-width: 120px;
`

const StyledRadio = styled(Radio)`
    ${baseFont}
    color: white !important;

    @media (max-width: 1024px) {
        color: #1d1d1d !important;
        .Radio__LabelText-sc-we59oz-4 {
            color: #1d1d1d !important;
        }
    }
`

const RadioInputStyledLabel = styled(Typography)`
    ${baseFont}
    color: #6f6f6f;
    flex: 1;
    text-align: left;
    min-width: 100px;
    @media (max-width: 1024px) {
        color: #585858;
    }
`

export default LabelWithRadioButtons
